import { brtieDocuments, experienceLoopDocuments, innovationDocuments, persistentPlatfromDocuments, workfrontBasicsDocuments } from 'components/documentsContainer/data'

export const TABS = {
  WORKFRONT_BASICS: 'Workfront basics',
  EXPERIENCE_LOOP: 'Experience loop',
  INNOVATION: 'Innovation',
  PERSISTENT_PRODUCT_EDGE: 'Persistent Product Edge',
  BRITE: 'Brite',
}

export const TAB_DOCUMENT_MAP = {
  [TABS.WORKFRONT_BASICS]: workfrontBasicsDocuments,
  [TABS.EXPERIENCE_LOOP]: experienceLoopDocuments,
  [TABS.INNOVATION]: innovationDocuments,
  [TABS.PERSISTENT_PRODUCT_EDGE]: persistentPlatfromDocuments,
  [TABS.BRITE]: brtieDocuments,
}

export const tabs = Object.values(TABS)